import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const initialState = {
  status: null,
  data: null,
  message: null,
};

export const getPlanDetails = createAsyncThunk(
  "getPlanDetails",
  async () => {
    const response = await fetch("/api/getPlans", {
      method: "GET",
    });

    if (!response.ok) {
      throw new Error("Failed to fetch plans");
    }

    return await response.json();
  }
);

const plansSlice = createSlice({
  name: "plans",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(getPlanDetails.pending, (state) => {
        state.status = "INPROGRESS";
        state.data = null;
        state.message = null;
      })

      .addCase(getPlanDetails.fulfilled, (state, action) => {

        state.status = "SUCCESS";

        // Change this based on your API response structure
        const data = JSON.parse(action.payload?.data);
        state.data = data?.data;

        state.message = "Completed";
      })

      .addCase(getPlanDetails.rejected, (state, action) => {
        state.status = "FAILED";
        state.data = null;
        state.message = action.error.message;
      });
  },
});

export default plansSlice.reducer;